export default __webpack_public_path__ + "static/media/dots.7d43f162.svg";